import Preset, { AtomisablePreset } from 'domain/entity/preset';

export type Features = Feature[];

export type BusinessInsight = {
    type: string;
    feature: string;
    label: string;
};

export default class Feature {
    constructor(
        readonly name: string,
        readonly key: string,
        readonly presets: Preset[],
        readonly atomisablePresets: AtomisablePreset[],
        readonly businessInsights: BusinessInsight[] = []
    ) {}
}
